import { render } from "./video-list.vue?vue&type=template&id=6bb31a3e&scoped=true"
import script from "./video-list.vue?vue&type=script&lang=js"
export * from "./video-list.vue?vue&type=script&lang=js"

import "./video-list.vue?vue&type=style&index=0&id=6bb31a3e&scoped=true&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb31a3e"]])

export default __exports__